import { z } from 'zod';
export var AgenticPlatformCallbackOperation;
(function (AgenticPlatformCallbackOperation) {
    AgenticPlatformCallbackOperation["IdentityRead"] = "IdentityRead";
    // Read-only notification access through agent-enabled endpoints, within the signed org grant.
    AgenticPlatformCallbackOperation["NotificationRead"] = "NotificationRead";
    // Read-only previsit form set access through agent-enabled endpoints, within the signed org grant.
    AgenticPlatformCallbackOperation["FormSetRead"] = "FormSetRead";
    /*
     * Read-only previsit form template access, within the signed org grant. Separate from FormSetRead
     * because a template is authored content gated by ViewPrevisitFormTemplates, while a form set is
     * a patient's copy gated by practice access; one operation would pool the two.
     */
    AgenticPlatformCallbackOperation["FormTemplateRead"] = "FormTemplateRead";
    // Read-only feed access through agent-enabled endpoints, within the signed org grant.
    AgenticPlatformCallbackOperation["FeedRead"] = "FeedRead";
    // Read-only scenario access through agent-enabled endpoints, within the signed org grant.
    AgenticPlatformCallbackOperation["ScenarioRead"] = "ScenarioRead";
    /*
     * Names an organization the grant already holds. It mirrors no group permission because the
     * endpoint it covers has none: a browser caller reaches it on membership alone.
     */
    AgenticPlatformCallbackOperation["OrganizationRead"] = "OrganizationRead";
    /*
     * Read-only practice lookup, within the signed org grant. Separate from OrganizationRead because
     * a practice read is gated by ViewBasicPractices or ViewPractices, while an organization read
     * mirrors no group permission.
     */
    AgenticPlatformCallbackOperation["PracticeRead"] = "PracticeRead";
    // Read-only assistant conversation access through agent-enabled endpoints, within the signed org grant.
    AgenticPlatformCallbackOperation["ConversationRead"] = "ConversationRead";
    /*
     * Read-only access to how an assistant is configured, within the signed org grant. Separate from
     * ConversationRead because a conversation is what a patient said and is gated by the conversation
     * permissions, while a definition is authored configuration gated by ViewVoiceAssistant.
     */
    AgenticPlatformCallbackOperation["AssistantRead"] = "AssistantRead";
    // Read-only integration connection access through agent-enabled endpoints, within the signed org grant.
    AgenticPlatformCallbackOperation["ConnectionRead"] = "ConnectionRead";
    AgenticPlatformCallbackOperation["FlowAnalyticsRead"] = "FlowAnalyticsRead";
    AgenticPlatformCallbackOperation["FlowBlockDataAnalyticsRead"] = "FlowBlockDataAnalyticsRead";
    AgenticPlatformCallbackOperation["ReferenceTableRead"] = "ReferenceTableRead";
    /*
     * Read-only patient record and encounter lookups, within the signed org grant. Its own operation
     * because it is gated by Search, the staff patient search permission, unlike FormSetRead, which
     * every chat user receives.
     */
    AgenticPlatformCallbackOperation["PatientRead"] = "PatientRead";
    /*
     * Read-only notification send history, within the signed org grant. Separate from
     * NotificationRead, which covers configuration and carries no PHI, because it is what a patient
     * was sent and is gated by ViewTimeline.
     */
    AgenticPlatformCallbackOperation["NotificationHistoryRead"] = "NotificationHistoryRead";
})(AgenticPlatformCallbackOperation || (AgenticPlatformCallbackOperation = {}));
/** Scope is embedded in a JWT inside x-notable-user; keep its contribution bounded. */
export const RequestedAgenticPlatformCallbackScopeSchema = z
    .object({
    organizationIds: z
        .array(z.uuid())
        .max(50)
        .transform((ids) => ids.map((id) => id.toLowerCase()))
        .refine((ids) => new Set(ids).size === ids.length, {
        message: 'Requested organizations must not contain duplicates',
    }),
    operations: z
        .array(z.enum(AgenticPlatformCallbackOperation))
        .max(Object.values(AgenticPlatformCallbackOperation).length)
        .refine((operations) => new Set(operations).size === operations.length, {
        message: 'Requested operations must not contain duplicates',
    }),
})
    .strict();
//# sourceMappingURL=callbackScope.js.map